import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';

import PropsRoute from './components/wrappers/props-route';
import asyncComponent from './components/wrappers/async-component';
import Main from './components/main/main';
import ScrolToTop from './components/helpers/scroll-top.helper';
import styles from './app.module.css';
import { connect } from 'react-redux';
import { fetchCurrentUser } from './reducers/user.reducer';

const AsyncLogin = asyncComponent(() => import('./components/login/login'));
const AsyncError = asyncComponent(() => import('./components/error/error'));

class App extends React.Component {
  constructor(props) {
    super(props);
    const token = localStorage.getItem('token');

    if (token) {
      props.dispatch(fetchCurrentUser());
    }
  }

  render() {
    const { history } = this.props;

    return (
      <div className={styles.app}>
        <Router history={history}>
          <ScrolToTop>
            <Switch>
              <Route
                path="/login"
                exact
                component={AsyncLogin}
                props={this.props}
              />
              <PropsRoute exact path="/404" component={AsyncError} code="404" />
              <PropsRoute exact path="/500" component={AsyncError} code="500" />
              <Route path="/" component={Main} />
            </Switch>
          </ScrolToTop>
        </Router>
      </div>
    );
  }
}

export default connect()(App);



// WEBPACK FOOTER //
// ./src/app.js